import * as React from 'react';

export type Props = {
  meta: MetaData;
  isBlogPost?: boolean;
};

const HeadPost = ({ meta, isBlogPost }: Props) => (
  <>
    <h1 className={`font-bold text-gray-800 mb-4 ${isBlogPost ? 'text-5xl mt-8 mb-8' : 'text-lg'}`}>{meta.title}</h1>
    <div className="details">
      <p className="text-gray-500">{meta.description}</p>
      <p className="text-gray-400 text-right -mt-1">
        <span className="mr-4">{meta.date}</span>
      </p>
    </div>
  </>
);

export default HeadPost;
